<template>
  <div>
    <div v-show="list.length" class="rank-list">
      <div class="rowName">
        <div class="col" style="width: 20%">序号</div>
        <div class="col" style="width: 32%">用户昵称</div>
        <div class="col" style="width: 23%">头像</div>
        <div class="col">祭拜次数</div>
      </div>
      <div v-for="(item,index) of list" :key="index" class="rank-item">
        <div :class="index<3? 'big' : ''" class="col" style="width: 20%">{{ index + 1 }}</div>
        <div class="col text-cut" style="width: 32%">{{ item.name }}</div>
        <div class="col flex-row-center-center" style="width: 23%">
          <img v-if="item.headPicture" :src="$resUrl(item.headPicture)" alt>
          <img v-if="!item.headPicture" alt src="@/assets/images/avatar-default.png">
        </div>
        <div class="col">{{ item.count }}</div>
      </div>
    </div>
    <div v-show="!list.length" class="noData">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: 'RankRecord',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang='scss' scoped>
.rank-list {
  background: #fff;
  // padding: 15px 0px;
  border-radius: 6px;
  box-shadow: 0px 0px 4px 4px #eee;
  font-size: 13px;

  .rowName,
  .rank-item {
    display: flex;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #eee;

    .col {
      width: 25%;
      text-align: center;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
    }

    .big {
      font-size: 18px;
      font-weight: bold;
    }
  }
}

.noData {
  text-align: center;
  color: #bbb;
}
</style>
